import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { focusCloseButton, IFormModalRef, reactModalProps } from '../modal';

export interface IFormSoftwareModal {
    onCloseAndContinue: React.EventHandler<any>;
}

const FormSoftwareModal = (props: IFormSoftwareModal, ref: ForwardedRef<IFormModalRef>) => {
    const { t } = useTranslation();
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
        if (!modalIsOpen) {
            document.body.classList.remove('modal-open');
        } else {
            focusCloseButton();
        }
    }, [modalIsOpen]);

    useImperativeHandle(ref, () => {
        return {
            setModalOpen(value: boolean) {
                setModalIsOpen(value);
            },
        };
    });

    const closeAndContinue = () => {
        setModalIsOpen(false);
        props.onCloseAndContinue(null);
    };

    ReactModal.setAppElement('#root');
    return (
        <ReactModal
            aria-label={t('modal_software_container_aria_label', { ns: 'accessibility' })}
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            contentLabel={t('form_modal_software_header')}
            {...reactModalProps}
        >
            <button
                className="modal__close-icon"
                onClick={() => setModalIsOpen(false)}
                aria-label={t('modal_close_aria_label', { ns: 'accessibility' })}
                id="modal_close_button"
            >
                <span className="visuallyhidden">
                    {t('modal_close_aria_label', { ns: 'accessibility' })}
                </span>
                <span aria-hidden="true">×</span>
            </button>
            <div className="body-medium">
                <div className="header-1 modal-header">{t('form_modal_software_header')}</div>
                <br />
                <div>{t('form_modal_software_description')}</div>
                <ul>
                    <li>{t('form_modal_software_element_1')}</li>
                    <li>{t('form_modal_software_element_2')}</li>
                </ul>
                <div>
                    <i>{t('form_modal_software_notice')}</i>
                </div>
                <br />
                <div className="modal-bottom-element">{t('form_modal_software_footer')}</div>
                <div className="modal-center-button-container">
                    <button
                        className="button button--primary modal-center-button modal-center-button--split"
                        onClick={() => setModalIsOpen(false)}
                    >
                        {t('form_modal_software_yes')}
                    </button>
                    <button
                        className="button button--primary modal-center-button modal-center-button--split"
                        onClick={closeAndContinue}
                    >
                        {t('form_modal_software_no')}
                    </button>
                </div>
            </div>
        </ReactModal>
    );
};

export default forwardRef(FormSoftwareModal);
